import { type CSSProperties, type ReactNode, useId } from "react";
import { t } from "../../i18n";
export function CostHelp({
  title,
  children,
}: { title: string; children: ReactNode }): React.JSX.Element {
  const id = useId();
  return (
    <>
      <button
        type="button"
        popoverTarget={id}
        aria-haspopup="dialog"
        aria-label={`${title} · ${t("cost.help")}`}
        style={triggerStyle}
      >
        ?
      </button>
      <dialog
        id={id}
        popover="auto"
        aria-labelledby={`${id}-title`}
        style={panelStyle}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
          }}
        >
          <strong id={`${id}-title`}>{title}</strong>
          <button
            type="button"
            popoverTarget={id}
            popoverTargetAction="hide"
            aria-label={t("cost.close_help")}
            style={closeStyle}
          >
            ×
          </button>
        </div>
        {children}
      </dialog>
    </>
  );
}
const triggerStyle: CSSProperties = {
  display: "inline-grid",
  placeItems: "center",
  width: 18,
  height: 18,
  borderRadius: "50%",
  border: "1px solid #a5adb9",
  background: "transparent",
  color: "#6c7582",
  fontSize: 12,
  fontWeight: 500,
  padding: 0,
  marginLeft: 7,
  verticalAlign: "middle",
  cursor: "pointer",
};
const panelStyle: CSSProperties = {
  position: "fixed",
  inset: 0,
  margin: "auto",
  height: "fit-content",
  width: "min(340px,calc(100vw - 48px))",
  maxHeight: "70vh",
  overflowY: "auto",
  padding: 20,
  border: "1px solid var(--color-border)",
  borderRadius: 10,
  background: "var(--color-bg)",
  color: "var(--color-text)",
  boxShadow: "0 8px 40px #0002",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.7,
};
const closeStyle: CSSProperties = {
  border: 0,
  background: "transparent",
  color: "inherit",
  fontSize: 20,
  cursor: "pointer",
};
